var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompany(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 101,
    viewBox: "0 0 100 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 43.51V3.5H41L97 59.5L57 99.5L1 43.51Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9299 25.2701C20.1552 25.2701 22.7698 22.6554 22.7698 19.4301C22.7698 16.2047 20.1552 13.5901 16.9299 13.5901C13.7045 13.5901 11.0898 16.2047 11.0898 19.4301C11.0898 22.6554 13.7045 25.2701 16.9299 25.2701Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9504 45.8999L66.5004 57.4499L54.9504 68.9999L43.4004 57.4499",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5101 48.5599L31.6201 45.6699L43.1702 34.1199L46.0601 37.0099",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6603 39.6099C51.8503 42.7999 51.8503 47.9699 48.6603 51.1599C45.4703 54.3499 40.3004 54.3499 37.1104 51.1599",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1605 55.48L52.9805 59.67",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2297 78.37C36.2297 83.7 31.9097 88.02 26.5797 88.02C21.2497 88.02 16.9297 83.7 16.9297 78.37V25.27",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6201 19.2499L74.3301 21.84L82.6201 24.4299L85.2101 32.72L87.8001 24.4299L96.1001 21.84L87.8001 19.2499L85.2101 10.95L82.6201 19.2499Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5996 8.14008L59.0596 8.4101L60.5996 8.68005L60.8696 10.2301L61.1396 8.68005L62.6896 8.4101L61.1396 8.14008L60.8696 6.6001L60.5996 8.14008Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9404 89.58L83.4004 89.85L84.9404 90.12L85.2104 91.67L85.4804 90.12L87.0204 89.85L85.4804 89.58L85.2104 88.04L84.9404 89.58Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4102 10.8699L89.1702 59.6299L57.1301 91.6699L8.37012 42.9099",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/company.62057271a590ae5416d4161a28487ed4.svg";
export { ForwardRef as ReactComponent };